import { twMerge } from 'tailwind-merge';

import { Avatar, AvatarFallback, AvatarImage, Badge, Text } from '@/_components';

import type { InvoiceEmailRecipient } from '../get-invoice-email-recipients';
import { invoiceEmailRecipientRoleLabel } from '../get-invoice-email-recipients';

const roleLabel = invoiceEmailRecipientRoleLabel;

type InvoiceEmailRecipientItemProps = {
  recipient: InvoiceEmailRecipient;
  compact?: boolean;
};

export function InvoiceEmailRecipientItem({ recipient, compact = false }: InvoiceEmailRecipientItemProps) {
  return (
    <li className={twMerge('flex items-center', compact ? 'gap-2' : 'gap-3')}>
      <Avatar size="sm" className={twMerge('shrink-0', compact ? 'size-6' : 'size-8')}>
        <AvatarImage src={recipient.avatarUrl ?? undefined} className="object-cover" />
        <AvatarFallback name={recipient.name} className={compact ? 'text-[10px]' : 'text-xs'} />
      </Avatar>
      <div className="min-w-0 flex-1">
        <div className="flex flex-wrap items-center gap-1.5">
          <Text className={twMerge('text-c-card-foreground truncate font-medium', compact ? 'text-xs' : 'text-sm')}>
            {recipient.name}
          </Text>
          <Badge type="neutral" size="sm" className="shrink-0 text-[10px]">
            {roleLabel[recipient.role]}
          </Badge>
        </div>
        <Text
          className={twMerge('text-c-card-muted mt-0.5 truncate', compact ? 'text-[10px]' : 'text-xs')}
          title={recipient.email ?? undefined}
        >
          {recipient.email ?? 'No email on file'}
        </Text>
      </div>
    </li>
  );
}
